import { render, staticRenderFns } from "./pohon_kinerja.vue?vue&type=template&id=2daf64cf&"
import script from "./pohon_kinerja.vue?vue&type=script&lang=js&"
export * from "./pohon_kinerja.vue?vue&type=script&lang=js&"
import style0 from "./pohon_kinerja.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports